// checkout product button
(function () {
    document.addEventListener('click', function (event) {
        const buyNowButton = event.target.closest('#add-to-cart-and-checkout');
        if (!buyNowButton) return;

        event.preventDefault();

        const form = buyNowButton.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;

        const formData = new FormData(form);
        const item = {
            id: Number(formData.get('id')),
            quantity: Number(formData.get('quantity') || 1)
        };
        const properties = {};

        for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value) {
                properties[match[1]] = value;
            }
        }

        if (Object.keys(properties).length) {
            item.properties = properties;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [item]
            })
        })
            .then((response) => {
                if (response.ok) {
                    window.location.href = '/checkout';
                } else {
                    console.error('Error');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });
})();
// checkout product button

// add save price in ymq table
(function () {
    window.addEventListener("load", function() {
        if (document.querySelector('.ymq-b2b-table')) {
            const basePrice = parseFloat(document.querySelector('.ymq-b2b-current-product-price-parent-dom .ymq-b2b-price-span').getAttribute('data-ymq-money'));

            document.querySelectorAll('.ymq-b2b-table-tr').forEach(row => {
                const quantity = parseInt(row.getAttribute('ymq-b2b-table-min'));
                const priceSpan = row.querySelector('.ymq-b2b-price-span');
                const discountedPrice = parseFloat(priceSpan.getAttribute('data-ymq-money'));
                const totalDiscount = (basePrice - discountedPrice) * quantity;
                
                const discountText = document.createElement('div');
                discountText.style.color = '#00fd13';
                if (document.querySelector('html').getAttribute('lang') == 'fr') {
                    discountText.textContent = ` (Écon. $${totalDiscount.toFixed(2)}/cmd)`;
                } else {
                    discountText.textContent = ` (Save $${totalDiscount.toFixed(2)} per order)`;
                }
                
    
                priceSpan.parentElement.appendChild(discountText);
            });
        }
    });
})();
// add save price in ymq table

// featured_collection_v2__products slider
(function () {
    document.addEventListener('DOMContentLoaded', function() {
        const swipers = new Map();

        // Инициализация слайдера
        function initSwiper(element) {
            if (!element) return null;
            
            return new Swiper(element, {
                slidesPerView: 1.3,
                spaceBetween: 15,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: element.querySelector('.featured_collection_v2__slider-next'),
                    prevEl: element.querySelector('.featured_collection_v2__slider-prev'),
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3
                    },
                    1024: {
                        slidesPerView: 4
                    },
                }
            });
        }

        // Инициализация всех слайдеров
        document.querySelectorAll('.featured_collection_v2__products').forEach((element) => {
            const swiper = initSwiper(element);
            if (swiper) {
                swipers.set(element, swiper);
            }
        });

        // Табы
        const tabs = document.querySelectorAll('.featured_collection_v2__tabs-item');
        const contents = document.querySelectorAll('.featured_collection_v2__tabs-content');

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                // Снимаем активный класс
                tabs.forEach(t => t.classList.remove('active'));
                contents.forEach(c => c.classList.remove('active'));

                // Добавляем активный класс
                tab.classList.add('active');
                contents[index].classList.add('active');

                // Обновляем слайдер в активном табе
                setTimeout(() => {
                    const activeContent = contents[index];
                    const activeSwiper = activeContent.querySelector('.featured_collection_v2__products');
                    if (activeSwiper && swipers.has(activeSwiper)) {
                        swipers.get(activeSwiper).update();
                    }
                }, 100);
            });
        });
    });
})();
// featured_collection_v2__products slider

(function () {
    document.addEventListener('DOMContentLoaded', function() {
        // Находим все секции с видео
        const videoSections = document.querySelectorAll('.section_video');
        
        videoSections.forEach((section, index) => {
            const swiperContainer = section.querySelector('.section_video__grid');
            
            if (swiperContainer) {
                // Добавляем уникальный класс для каждой секции
                swiperContainer.classList.add('section_video__swiper-' + index);
                
                // Инициализируем Swiper
                const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length || 5;
                const desktopSlides = Math.min(slideCount, 5);

                new Swiper('.section_video__swiper-' + index, {
                    slidesPerView: 1.5,
                    spaceBetween: 15,
                    centeredSlides: false,
                    grabCursor: true,
                    breakpoints: {
                        480: {
                            slidesPerView: Math.min(2, desktopSlides),
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: Math.min(3, desktopSlides),
                            spaceBetween: 15
                        },
                        1024: {
                            slidesPerView: Math.min(4, desktopSlides),
                            spaceBetween: 15
                        },
                        1200: {
                            slidesPerView: desktopSlides,
                            spaceBetween: 15
                        }
                    }
                });
            }
        });
    });
})();

// banner slider
(function () {
    document.addEventListener('DOMContentLoaded', function() {
        const bannerSwipers = document.querySelectorAll('.banner_v2--slideshow .swiper');
        bannerSwipers.forEach((swiperElement) => {
            new Swiper(swiperElement, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: swiperElement.querySelector('.swiper-button-next'),
                    prevEl: swiperElement.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: swiperElement.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });
        });
    });
})();
// banner slider

// nav catalog btn
(function () {
    if (document.getElementById('nav_catalog')) {
        const navCatalogBtn = document.getElementById('nav_catalog');
        const navCatalogLink = document.querySelector('.footer_v2__block .header_v2_nav__catalog');
        const menuDrawer = document.querySelector('header-drawer');

        if (window.innerWidth > 767) {   
            // Клик по ссылке в футере
            navCatalogLink.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation(); // Останавливаем, чтобы не сработал клик по document
                navCatalogBtn.classList.toggle('is-active'); 
                
                // Прокрутка к меню, если оно вне зоны видимости
                navCatalogBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });

            // Клик в любом месте документа
            document.addEventListener('click', function(e) {
                // Если кликнули МИМО кнопки каталога — убираем класс
                if (!navCatalogBtn.contains(e.target)) {
                    navCatalogBtn.classList.remove('is-active');
                }
            });
        } else if (window.innerWidth <= 767) {

            navCatalogLink.addEventListener('click', function(e) {
                e.preventDefault();
                // Находим summary внутри мобильного меню
                const summaryElement = menuDrawer.querySelector('summary');
                
                // 1. Открываем сам тег details
                menuDrawer.mainDetailsToggle.setAttribute('open', '');
                
                // 2. Вызываем метод открытия, передавая summary
                menuDrawer.openMenuDrawer(summaryElement);
            });
        }
    }

})();
// nav catalog btn

// reviews slider
(function () {
    if (document.querySelector('.reviews__slider')) {
        const swiper = new Swiper('.reviews__slider', {
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: {
                nextEl: '.reviews__slider-next',
                prevEl: '.reviews__slider-prev',
            },
            pagination: {
                el: '.reviews__slider-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
            }
        });
    }
})();
// reviews slider